/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Clients API
 * AV Services Clients management API
 * OpenAPI spec version: 1.0
 */

export interface NotificationTemplateDto {
  /** Name of the template */
  name: string;
  /** List of affected devices(ids) */
  devices: string[];
  /** List of affected users(ids) */
  users: string[];
}
